import * as HttpService from "../../../../service/HttpService";


/**
 *查询内容发布列表
 */
export const findCmsArticle = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/article/findCmsArticle", params);
};

/**
 *内容发布和停用
 */
export const pubAndStopCmsArticle = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/article/pubAndStopCmsArticle", params);
};

/**
 *内容新增
 */
export const addCmsArticle = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/article/addCmsArticle", params);
};
/**
 *内容删除
 */
export const deleteCmsArticle = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/article/deleteCmsArticle", params);
};
/**
 *内容编辑
 */
export const updateCmsArticle = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/article/updateCmsArticle", params);
};
/**
 * 积分
 */
export const selectConfiguration = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/EnergyConfiguration/selectConfiguration",params);
};
/**
 * 积分新增
 */
export const addConfiguration = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/EnergyConfiguration/addConfiguration",params);
};
/**
 * 积分删除
 */
export const deleteConfiguration = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/EnergyConfiguration/deleteConfiguration",params);
};
/**
 * 积分编辑
 */
export const updateConfiguration = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/EnergyConfiguration/updateConfiguration",params);
};